module.exports = __webpack_public_path__ + "img/reqIcons.3bf091a9.svg";